export const TYPE_ALL = 'ALL';

export const SYSTEM_TAG_KEYWORDS = 'KEYWORDS' as const;
export const SYSTEM_TAG_PEOPLE = 'PEOPLE' as const;
export const SYSTEM_TAG_BRANDS = 'BRANDS' as const;
export const SYSTEM_TAG_CC = 'CC' as const;
export const SYSTEM_TAG_TEXT = 'TEXT' as const;
export const SYSTEM_TAG_BRAND_SAFETY = 'BRAND_SAFETY' as const;
export const SYSTEM_TAG_IAB = 'IAB' as const;

export const CUSTOM_TAG = 'LABEL' as const;
export const CUSTOM_TAG_NAME = 'LABEL_NAME' as const;
export const CUSTOM_TAG_VALUE = 'LABEL_VALUE' as const;

export const TYPE_DESCRIBE_TITLE = 'TITLE';
export const TYPE_DESCRIBE_PLOT = 'PLOT';

export const AVAILABLE_DEEP_SEARCH_TAGS = [
  SYSTEM_TAG_PEOPLE,
  SYSTEM_TAG_BRANDS,
  SYSTEM_TAG_CC,
  SYSTEM_TAG_TEXT,
  CUSTOM_TAG_VALUE,
] as const;

export const AVAILABLE_CHIP_TAGS = [
  CUSTOM_TAG_NAME,
  CUSTOM_TAG_VALUE,
  SYSTEM_TAG_PEOPLE,
  SYSTEM_TAG_BRANDS,
  SYSTEM_TAG_IAB,
  SYSTEM_TAG_KEYWORDS,
] as const;
